export default function Eyebrow({ children, style }) {
  return (
    <div style={{
      fontFamily: "var(--ui)",
      fontSize: 10.5,
      fontWeight: 600,
      color: "var(--ink-3)",
      textTransform: "uppercase",
      letterSpacing: 1.8,
      ...style,
    }}>{children}</div>
  );
}
